import { FC } from "react";

import { useTranslation } from "react-i18next";

import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import { getAnalyticsAttributes } from "./DialogCloseButton.utilities";
import { type IDialogCloseButtonProperties } from "./DialogCloseButton.types";

const DialogCloseButton: FC<IDialogCloseButtonProperties> = ({
  onClick,
  isDisabled,
  dataCy,
  analyticsEventType,
  analyticsProperties,
}) => {
  const { t } = useTranslation();

  return (
    <IconButton
      aria-label={t("myDocuments.addExternalFilesButton.closeCta")}
      onClick={onClick}
      disabled={isDisabled}
      data-cy={dataCy}
      {...getAnalyticsAttributes(analyticsEventType, analyticsProperties)}
      sx={{ position: "absolute", top: 16, right: 16, zIndex: 2, color: "text.primary" }}
    >
      <CloseIcon />
    </IconButton>
  );
};

export default DialogCloseButton;
